export default __webpack_public_path__ + "static/media/Q2-1.ed2a3f58.png";